import React from 'react';
// @ts-ignore
import ScriptWrittenIcon from '../../../../assets/img/med-icons/discharge-script.png';

const TimelineScriptWrittenIcon = () => {
  return (
    <img
      src={ScriptWrittenIcon}
      style={{ width: '24px' }}
      alt="Script written icon"
    />
  );
};

export default TimelineScriptWrittenIcon;
